




























import { Component, Vue, Prop } from "vue-property-decorator";

import axios from "axios";
import { Estimate } from "@/types";

import Loading from "../shared/Loading.vue";
import DisplayEstimates from "./DisplayEstimates.vue";

@Component({ components: { DisplayEstimates, Loading } })
export default class EstimateList extends Vue {
  loading: boolean = false;

  estimates: Estimate[] = [];

  error: boolean = false;

  mounted() {
    this.fetchEstimates();
  }

  async fetchEstimates() {
    this.loading = true;

    try {
      const { data } = await axios.get(
        process.env.VUE_APP_ADMIN_URL + "/admin/estimate",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );

      if (!data) {
        throw new Error("Unable to find estimates");
      }

      this.estimates = data;
      this.loading = false;
    } catch (err) {
      this.$store.commit("setSnackMessageWithColor", {
        message: err,
        color: "error",
      });
    }
  }

  handleBackClick() {
    this.$router.push({ name: "dashboard" });
  }

  async handleRefreshData() {
    await this.fetchEstimates();
    this.$store.commit("setSnackMessageWithColor", {
      message: "Data has been refreshed",
      color: "success",
    });
  }

  handleOnCreateNewEstimate() {
    this.$router.push({ name: "create-estimate" });
  }
}
